module.exports = __webpack_public_path__ + "img/pick2.61e2bf3a.png";